module.exports = {
    getTicketConfig: {
        url: '/js_ticket'
    }
};